<template>
  <div class="fee-table">
    <div class="head">
      <div class="td td1">期数</div>
      <div class="td td2">服务费归属</div>
      <div class="td td3">归属人类型</div>
      <div class="td td4">产品/险种名称</div>
      <div class="td td5">保费（元）</div>
      <div class="td td7">
        <span>服务费比例</span>
        <Tooltip transfer content="包括基础服务费和活动费">
          <i class="tip-icon">?</i>
        </Tooltip>
      </div>
      <div class="td td9">收入（元）</div>
      <div class="td td10">剩余收入（元）</div>
    </div>
    <div class="body">
      <div class="row-child" v-for="(item, i) in list" :key="i">
        <div class="td td1">
          {{ item.commissionNum == 1 ? '首期' : `第${$units.numberTransform(item.commissionNum)}期` }}
        </div>
        <div class="row-box">
          <div class="row-child" v-for="(item2, ii) in item.commissionInfoList" :key="ii">
            <!-- 出单归属异常 -->
            <div class="row-box" v-if="!item2.owerName">
              <div class="error-box">出单归属参数缺失，无法计算业务员费用</div>
            </div>
            <template v-else>
              <!-- 服务费归属 -->
              <div class="td td2">{{ item2.owerName }}</div>
              <!-- 归属人类型 -->
              <div class="td td3">{{ item2.owerType }}</div>
              <div class="row-box" :class="{ 'hide-child': item2.hidden }">
                <div class="row-child" v-for="(item3, iii) in item2.policyInfoList" :key="iii" :class="{ 'hide-flag': iii > 0 }">
                  <div class="td td4">{{ item3.productName }}</div>
                  <!-- 保费异常 -->
                  <div class="row-box" v-if="item3.fee == null">
                    <div class="error-box">保费缺失，无法计算费用</div>
                  </div>
                  <template v-else>
                    <div class="td td5">{{ item3.fee }}</div>
                    <!-- 费用异常 -->
                    <!-- 存在附加险时第一行是合计不判断，不存在附加险时都判断 -->
                    <div class="row-box" v-if="item3.commission == null && ((iii != 0 && item2.policyInfoList.length > 1) || (item2.policyInfoList.length == 1))">
                      <div class="error-box">{{ item3.noCommissionReason }}</div>
                    </div>
                    <template v-else>
                      <!-- 费用 -->
                      <div class="td td7">
                        <!-- {{ item3.commission ? item3.commission + "%" : "" }}
                        <span style="color: red; margin-left: 5px" v-if="item3.rewardRate">+{{ item3.rewardRate }}%</span>
                        <span v-if="item3.commission && item3.activityCommission > 0" style="color: #ff5426">+</span>
                        <span v-if="item3.activityCommission > 0" style="color: #ff5426">
                          {{ item3.activityCommission ? item3.activityCommission + '%' : '' }}
                        </span> -->
                        <div>
                          <span v-for="(itemCommission, indexCommission) in item3.commission" :key="indexCommission">
                            <span v-if="item3.commission && item3.commission.length>1 && (item3.commission[1] >= 0) && indexCommission !=0">+</span>
                            {{ itemCommission ? Number(itemCommission).mul(100) + '%' : '' }}
                          </span>
                          <span v-for="(itemAct, actIndex) in item3.activityCommission" :key="actIndex">
                            <span v-if="item3.activityCommission && item3.activityCommission.length>1 && item3.activityCommission[1] >= 0 && actIndex !=0">+</span>
                            {{ Number(itemAct).mul(100) + '%' }}
                          </span>
                        </div>
                        <div style="display: inline-block" v-if="item3.merchantActivity">
                          <span style="color: orange">+{{ item3.merchantActivity.rewardRate + '%' }}</span>
                          <Tooltip>
                            <Icon type="ios-help-circle" size="16" />
                            <template #content>
                              <p>
                                活动时间：{{ item3.merchantActivity.startTime | filterTime('YYYY/MM/DD') }}-{{
                                  item3.merchantActivity.endTime | filterTime('YYYY/MM/DD')
                                }}
                              </p>
                              <p>活动名称：{{ item3.merchantActivity.name }}</p>
                            </template>
                          </Tooltip>
                        </div>
                      </div>
                      <!-- 收入（元） -->
                      <div class="td td9">{{ item3.totalIncome }}</div>
                      <!-- 剩余收入（元） -->
                      <div class="td td10">
                        {{ item3.residualIncome }}
                        <Icon
                          size="20"
                          :type="item2.hidden ? 'md-arrow-dropdown' : 'md-arrow-dropup'"
                          @click="toggleTable(item2)"
                          v-show="iii == 0 && item2.policyInfoList.length > 1"
                        />
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: null
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 切换表格子内容显示
    toggleTable(item) {
      this.$set(item, 'hidden', !item.hidden);
    },
  }
};
</script>
<style lang="scss" scoped>
@import './commissionInfoTable.scss';
</style>
